import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const stateText = (state, t) => ({ done: t.stepDone, current: t.stepCurrent, blocked: t.stepBlocked, todo: t.stepTodo }[state]);

/** The six steps of a custom app with where the request is now. `progress` comes from the backend. */
export default function StatusStepper({ progress, compact = false }) {
  const { language } = useLanguage();
  const t = translations[language];
  if (!progress?.steps) return null;

  return <ol className={`stepper${compact ? ' stepper--compact' : ''}`} aria-label={t.stepperLabel}>
    {progress.steps.map((step, index) => (
      <li key={step.status} className={`step is-${step.state}`} aria-current={step.state === 'current' || step.state === 'blocked' ? 'step' : undefined}>
        <span className="step__dot" aria-hidden="true"><span className="step__num">{step.state === 'blocked' ? '!' : index + 1}</span></span>
        <span className="step__label">{t.statusLabel[step.status]}</span>
        <span className="sr-only"> ({stateText(step.state, t)})</span>
      </li>
    ))}
  </ol>;
}
